// React
import React from 'react';
// Components
import Conditional from '../common/conditional';
import DialogAlertIcon from '../icons/dialog-alert-icon';
// Styles
import useStyles from './OrderDetailDialogErrorBody.styles';

const OrderDetailDialogErrorBody = ({
  classes,
  message,
  expressionText,
  title,
}) => {
  const componentClasses = useStyles();
  return (
    <div className={componentClasses.root}>
      <DialogAlertIcon />
      <div className={componentClasses.infoContainer}>
        <div className={componentClasses.headerContainer}>
          <div className={componentClasses.expresionContainer}>
            {expressionText}
          </div>
          <div className={componentClasses.titleContainer}>{title}</div>
        </div>
        <Conditional if={message}>
          <div className={componentClasses.messageContainer}>{message}</div>
        </Conditional>
      </div>
    </div>
  );
};

OrderDetailDialogErrorBody.defaultProps = {
  classes: {},
};

export default OrderDetailDialogErrorBody;
